module.exports = __webpack_public_path__ + "static/media/steam-social-media-svgrepo-com.f424285d.svg";